import { render, staticRenderFns } from "./EditGoalValueModal.vue?vue&type=template&id=e64eafcc"
import script from "./EditGoalValueModal.vue?vue&type=script&lang=ts"
export * from "./EditGoalValueModal.vue?vue&type=script&lang=ts"
import style0 from "./EditGoalValueModal.vue?vue&type=style&index=0&id=e64eafcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports